import { css } from 'styled-components';
import {
  getSpacing, SpacingName,
} from '@doveit/lego';

export const interstitialAd = ({ theme }) => css`
  ${getSpacing.marginTop(theme, SpacingName.MEDIUM)}
`;
